// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file lage/v1/lage.proto (package connectrpc.lage.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PingRequest () {
        return PingRequest;
    },
    get PingResponse () {
        return PingResponse;
    },
    get RunTargetRequest () {
        return RunTargetRequest;
    },
    get RunTargetResponse () {
        return RunTargetResponse;
    }
});
const _protobuf = require("@bufbuild/protobuf");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class RunTargetRequest extends _protobuf.Message {
    static fromBinary(bytes, options) {
        return new RunTargetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunTargetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunTargetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return _protobuf.proto3.util.equals(RunTargetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: optional string package_name = 1;
   */ _define_property(this, "packageName", void 0), /**
   * @generated from field: string task = 2;
   */ _define_property(this, "task", ""), /**
   * @generated from field: repeated string taskArgs = 3;
   */ _define_property(this, "taskArgs", []), /**
   * @generated from field: string nodeOptions = 4;
   */ _define_property(this, "nodeOptions", ""), /**
   * @generated from field: string npmClient = 5;
   */ _define_property(this, "npmClient", "");
        _protobuf.proto3.util.initPartial(data, this);
    }
}
_define_property(RunTargetRequest, "runtime", _protobuf.proto3);
_define_property(RunTargetRequest, "typeName", "connectrpc.lage.v1.RunTargetRequest");
_define_property(RunTargetRequest, "fields", _protobuf.proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "package_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 2,
            name: "task",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "taskArgs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "nodeOptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "npmClient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
class RunTargetResponse extends _protobuf.Message {
    static fromBinary(bytes, options) {
        return new RunTargetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunTargetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunTargetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return _protobuf.proto3.util.equals(RunTargetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: optional string package_name = 2;
   */ _define_property(this, "packageName", void 0), /**
   * @generated from field: string cwd = 3;
   */ _define_property(this, "cwd", ""), /**
   * @generated from field: string task = 4;
   */ _define_property(this, "task", ""), /**
   * @generated from field: int32 exit_code = 5;
   */ _define_property(this, "exitCode", 0), /**
   * @generated from field: repeated string inputs = 6;
   */ _define_property(this, "inputs", []), /**
   * @generated from field: repeated string outputs = 7;
   */ _define_property(this, "outputs", []), /**
   * @generated from field: string stdout = 8;
   */ _define_property(this, "stdout", ""), /**
   * @generated from field: string stderr = 9;
   */ _define_property(this, "stderr", ""), /**
   * @generated from field: string global_input_hash_file = 10;
   */ _define_property(this, "globalInputHashFile", "");
        _protobuf.proto3.util.initPartial(data, this);
    }
}
_define_property(RunTargetResponse, "runtime", _protobuf.proto3);
_define_property(RunTargetResponse, "typeName", "connectrpc.lage.v1.RunTargetResponse");
_define_property(RunTargetResponse, "fields", _protobuf.proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "package_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 3,
            name: "cwd",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "task",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "exit_code",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "inputs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "outputs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "stdout",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "stderr",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "global_input_hash_file",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
class PingRequest extends _protobuf.Message {
    static fromBinary(bytes, options) {
        return new PingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return _protobuf.proto3.util.equals(PingRequest, a, b);
    }
    constructor(data){
        super();
        _protobuf.proto3.util.initPartial(data, this);
    }
}
_define_property(PingRequest, "runtime", _protobuf.proto3);
_define_property(PingRequest, "typeName", "connectrpc.lage.v1.PingRequest");
_define_property(PingRequest, "fields", _protobuf.proto3.util.newFieldList(()=>[]));
class PingResponse extends _protobuf.Message {
    static fromBinary(bytes, options) {
        return new PingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return _protobuf.proto3.util.equals(PingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool pong = 1;
   */ _define_property(this, "pong", false);
        _protobuf.proto3.util.initPartial(data, this);
    }
}
_define_property(PingResponse, "runtime", _protobuf.proto3);
_define_property(PingResponse, "typeName", "connectrpc.lage.v1.PingResponse");
_define_property(PingResponse, "fields", _protobuf.proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "pong",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
